(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-purchase-decision-poll"] && !Shopify.designMode) return;
  try {
    
(function () {
  const ANSWERED_KEY = '1000v_purchase_poll_answered_v1';
  const PRESENTED_SESSION_KEY = '1000v_purchase_poll_presented_session_v1';
  const SESSION_START_KEY = '1000v_purchase_poll_session_start_v1';
  const UNIQUE_PAGES_KEY = '1000v_purchase_poll_unique_pages_v1';
  const RESPONSE_ID_KEY = '1000v_purchase_poll_response_id_v1';
  const TRIGGER_KEY = '1000v_purchase_poll_trigger_v1';

  function safeGet(storage, key) {
    try { return storage.getItem(key); } catch (e) { return null; }
  }

  function safeSet(storage, key, value) {
    try { storage.setItem(key, value); } catch (e) {}
  }
function getResponseId() {
  let id = safeGet(sessionStorage, RESPONSE_ID_KEY);

  if (!id) {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      id = window.crypto.randomUUID();
    } else {
      id = 'poll_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2);
    }

    safeSet(sessionStorage, RESPONSE_ID_KEY, id);
  }

  return id;
}
  function publish(name, data) {
    const payload = Object.assign({
      page_url: window.location.href,
      page_path: window.location.pathname,
      page_title: document.title,
      timestamp: new Date().toISOString()
    }, data || {});

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, payload);
      }
    } catch (e) {}

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name.replace(':', '_'), payload);
      }
    } catch (e) {}

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name.replace(':', '_') }, payload));
    } catch (e) {}
  }

  function isMeaningfulPage() {
    const path = window.location.pathname.toLowerCase();

    if (
      path === '/' ||
      path.startsWith('/products/') ||
      path.startsWith('/collections/') ||
      path.startsWith('/pages/') ||
      path.startsWith('/blogs/')
    ) {
      return true;
    }

    return false;
  }

  function updateUniquePageCount() {
    let pages = [];

    try {
      pages = JSON.parse(safeGet(sessionStorage, UNIQUE_PAGES_KEY) || '[]');
      if (!Array.isArray(pages)) pages = [];
    } catch (e) {
      pages = [];
    }

    const pageKey = window.location.pathname + window.location.search;

    if (isMeaningfulPage() && !pages.includes(pageKey)) {
      pages.push(pageKey);
      safeSet(sessionStorage, UNIQUE_PAGES_KEY, JSON.stringify(pages));
    }

    return pages.length;
  }

  function initPoll(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const designMode = root.dataset.designMode === 'true';
    const dialog = root.querySelector('.purchase-poll__dialog');
    const questionStep = root.querySelector('[data-poll-step="question"]');
    const thanksStep = root.querySelector('[data-poll-step="thanks"]');
    const submitButton = root.querySelector('[data-poll-submit]');
    const closeButtons = root.querySelectorAll('[data-poll-close]');
    const answerInputs = root.querySelectorAll('[data-poll-answer]');
    const otherWrap = root.querySelector('[data-other-wrap]');
    const otherInput = root.querySelector('[data-poll-other]');
    const emailInput = root.querySelector('[data-poll-email]');
    const emailForm = root.querySelector('form[action*="/contact"]');
    const errorBox = root.querySelector('[data-poll-error]');

    const timeTriggerSeconds = Math.max(1, parseInt(root.dataset.timeTrigger || '45', 10));
    const pageTriggerCount = Math.max(1, parseInt(root.dataset.pageTrigger || '3', 10));
    const exitTriggerEnabled = root.dataset.exitTrigger === 'true';

    let hasOpened = false;
    let timerId = null;

    function alreadyAnswered() {
      return safeGet(localStorage, ANSWERED_KEY) === 'true';
    }

    function alreadyPresentedThisSession() {
      return safeGet(sessionStorage, PRESENTED_SESSION_KEY) === 'true';
    }

    function eligible() {
      return !alreadyAnswered() && !alreadyPresentedThisSession() && !hasOpened;
    }

    function showPoll(trigger) {
      if (!eligible() && !designMode) return;

      hasOpened = true;

      safeSet(sessionStorage, TRIGGER_KEY, trigger);
      const pollResponseId = getResponseId();

      if (!designMode) {
        safeSet(sessionStorage, PRESENTED_SESSION_KEY, 'true');
      }

      root.hidden = false;
      document.body.classList.add('purchase-poll-open');

      if (questionStep) questionStep.hidden = false;
      if (thanksStep) thanksStep.hidden = true;

      window.setTimeout(function () {
        if (dialog) dialog.focus();
      }, 30);

      if (!designMode) {
      publish('1000vtools:purchase_poll_presented', {
      poll_response_id: pollResponseId,
      trigger: trigger,
      unique_page_count: updateUniquePageCount()
        });
      }
    }

    function closePoll() {
      root.hidden = true;
      document.body.classList.remove('purchase-poll-open');
    }

    function selectedAnswer() {
      return root.querySelector('[data-poll-answer]:checked');
    }

    function toggleOtherField() {
      const selected = selectedAnswer();
      if (!selected || !otherWrap) return;

      const isOther = selected.value.trim().toLowerCase() === 'other';
      otherWrap.hidden = !isOther;

      if (!isOther && otherInput) otherInput.value = '';
    }

    answerInputs.forEach(function (input) {
      input.addEventListener('change', toggleOtherField);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closePoll);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !root.hidden) closePoll();
    });

    if (submitButton) {
      submitButton.addEventListener('click', function () {
        const selected = selectedAnswer();

        if (!selected) {
          if (errorBox) {
            errorBox.textContent = 'Please select one answer.';
            errorBox.hidden = false;
          }
          return;
        }

        const answer = selected.value.trim();
        const otherText =
          answer.toLowerCase() === 'other' && otherInput
            ? otherInput.value.trim().slice(0, 500)
            : '';

        const email = emailInput ? emailInput.value.trim() : '';

        if (email && emailInput && !emailInput.checkValidity()) {
          if (errorBox) {
            errorBox.textContent = 'Please enter a valid email address or leave the email field blank.';
            errorBox.hidden = false;
          }
          emailInput.reportValidity();
          return;
        }

        if (errorBox) errorBox.hidden = true;

        safeSet(localStorage, ANSWERED_KEY, 'true');

        publish('1000vtools:purchase_poll_answered', {
        poll_response_id: getResponseId(),
        trigger: safeGet(sessionStorage, TRIGGER_KEY) || '',
        answer: answer,
        other_text: otherText,
        email_provided: Boolean(email)
      });

        if (email) {
        publish('1000vtools:purchase_poll_email_signup', {
        poll_response_id: getResponseId(),
        trigger: safeGet(sessionStorage, TRIGGER_KEY) || '',
        poll_answer: answer,
        email_provided: true
          });

          if (emailForm) {
            if (questionStep) questionStep.hidden = true;
            if (thanksStep) thanksStep.hidden = false;

            // Let analytics events enter the queue, then use Shopify's native
            // customer/newsletter form to create/update the marketing subscriber.
            window.setTimeout(function () {
              emailForm.requestSubmit();
            }, 150);
            return;
          }
        }

        if (questionStep) questionStep.hidden = true;
        if (thanksStep) thanksStep.hidden = false;
      });
    }

    if (designMode) {
      showPoll('theme_editor_preview');
      return;
    }

    if (alreadyAnswered() || alreadyPresentedThisSession()) return;

    const uniquePageCount = updateUniquePageCount();

    if (exitTriggerEnabled && window.matchMedia('(pointer: fine)').matches) {
      const exitIntentHandler = function (event) {
        if (event.clientY <= 10 && eligible()) {
          if (timerId) window.clearTimeout(timerId);
          showPoll('exit_intent');
          document.removeEventListener('mouseout', exitIntentHandler);
        }
      };

      document.addEventListener('mouseout', exitIntentHandler);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-purchase-poll]').forEach(initPoll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const poll = event.target.querySelector('[data-purchase-poll]');
    if (poll) initPoll(poll);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
